import EnOverlaySpinner from 'Components/feedback/EnOverlaySpinner/EnOverlaySpinner';
import EnSnackbar from 'Components/feedback/EnSnackbar/EnSnackbar.vue';
import EnTabs from 'Components/base/EnTabs/EnTabs.vue';
import EnPageTitle from 'Components/layout/EnPageTitle/EnPageTitle.vue';
import GeneralTab from './generalTab.vue';
import PasswordTab from './passwordTab.vue';
export default {
  __name: 'index',
  setup(__props, _ref) {
    let __expose = _ref.expose;
    __expose();
    const messageType = ref('info');
    const snackbar = ref();
    const user = ref({});
    const loading = ref(true);
    const breadcrumbInfo = ref([t('Authentication.settingsTitle')]);
    const _inject = inject('breadcrumb'),
      updateBreadcrumbs = _inject.updateBreadcrumbs;
    updateBreadcrumbs(breadcrumbInfo.value);
    const currentTab = ref('general');
    const tabs = [{
      value: 'general',
      label: t('Authentication.manage.general.titleV2')
    }, {
      value: 'password',
      label: t('Authentication.manage.password.titleV2')
    }];
    function pushMessage(message, type) {
      messageType.value = type;
      snackbar.value.pushMessage(message);
    }
    onBeforeMount(async () => {
      const requestBody = {
        Profile: true
      };
      const response = await fetch("/api/Configuration/GetConfigurationForUser", {
        method: 'POST',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(requestBody)
      });
      if (response.ok) {
        user.value = (await response.json()).UserProfile;
      }
      loading.value = false;
    });
    const __returned__ = {
      messageType,
      snackbar,
      user,
      loading,
      breadcrumbInfo,
      updateBreadcrumbs,
      currentTab,
      tabs,
      pushMessage,
      get EnOverlaySpinner() {
        return EnOverlaySpinner;
      },
      EnSnackbar,
      EnTabs,
      EnPageTitle,
      GeneralTab,
      PasswordTab
    };
    Object.defineProperty(__returned__, '__isScriptSetup', {
      enumerable: false,
      value: true
    });
    return __returned__;
  }
};